module.exports = __webpack_public_path__ + "media/Instruction_B42.5ba0e72b.mp3";